import { useState } from 'react';

import { PropTypes } from 'prop-types';
import { MdKeyboardArrowLeft, MdOutlineKeyboardDoubleArrowRight } from 'react-icons/md';
import { AnimatePresence, motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const MobileDrawer = ({ menulists, handleClose }) => {
    const [currentMenu, setCurrentMenu] = useState(null);

    const handleMainMenuItemClick = (menu) => {

        setCurrentMenu(menu);
    };

    const handleSubMenuItemClick = (subMenuItem) => {
        // Add logic to handle sub-menu item click, e.g., navigate to a page
        console.log(`Clicked on sub-menu item: ${subMenuItem.name}`);
        handleClose();
    };

    return (




        <div className="w-full h-full">

            {currentMenu ? (
                <AnimatePresence >
                    <motion.div
                        initial={{ x: "100%", opacity: 0 }}
                        animate={
                            {
                                x: 0,
                                opacity: 1
                            }
                        }
                        exit={{ x: "100%", opacity: 0 }}
                        transition={{ duration: 0.2 }}

                    >
                        <div className="flex items-center h-full justify-start gap-3 my-3">

                            <button aria-label="left" onClick={() => setCurrentMenu(null)} className="text-gray-200 focus:outline-none">
                                <MdKeyboardArrowLeft size={50} />
                            </button>

                            <span className="font-bold text-2xl uppercase">{currentMenu?.title}</span>
                        </div>
                        <div className='flex flex-col gap-5 items-start  p-4 w-full max-h-[calc(100vh-200px)] menu  overflow-y-auto  '>

                            {currentMenu?.items?.map((item, i) => (

                                <div
                                    key={i}
                                    className="mb-4">

                                    <Link to={item.link} onClick={() => handleSubMenuItemClick(item)} className=' flex gap-2  cursor-pointer font-bold items-center text-xl hover:underline-offset-8 hover:underline whitespace-nowrap'>
                                        {item.name}
                                    </Link>

                                </div>

                            ))
                            }
                        </div>
                    </motion.div>
                </AnimatePresence>
            ) : (
                // Show main menu items
                <div className='flex flex-col gap-5 items-start h-full p-4 w-full'>
                    {
                        menulists?.map((menu, index) => (

                            menu.items ?

                                <div key={index} className="w-full">
                                    <span onClick={() => menu.items ? handleMainMenuItemClick(menu) : handleSubMenuItemClick(menu)} className='uppercase cursor-pointer flex gap-2 font-bold w-full justify-between items-center text-xl hover:underline-offset-8 hover:underline whitespace-nowrap'> {menu?.title}<MdOutlineKeyboardDoubleArrowRight /></span>
                                </div>
                                :
                                <Link key={index} to={menu.link} onClick={handleClose} className='uppercase cursor-pointer flex gap-2 font-bold w-full justify-between items-center text-xl hover:underline-offset-8 hover:underline whitespace-nowrap'> {menu?.title}<MdOutlineKeyboardDoubleArrowRight /></Link>

                        ))
                    }
                </div>
            )}


        </div >
    );
};
MobileDrawer.propTypes = {
    menulists: PropTypes.array,
    handleClose: PropTypes.func
}
export default MobileDrawer;
